import { Shield, Star, MapPin, Award } from "lucide-react";
import { GOOGLE_REVIEWS_URL, YELP_URL } from "@/data/reviewLinks";

interface TrustBarProps {
  className?: string;
  theme?: "dark" | "light";
}

export function TrustBar({ className = "", theme = "light" }: TrustBarProps) {
  const isDark = theme === "dark";

  const items = [
    {
      icon: <Award className="h-6 w-6 text-primary" />,
      text: "A+ BBB Rating",
      subtext: "Accredited Business",
    },
    {
      icon: <Star className="h-6 w-6 text-primary fill-current" />,
      text: "5.0 Stars",
      subtext: "Google Reviews",
      href: GOOGLE_REVIEWS_URL,
    },
    {
      icon: <Star className="h-6 w-6 text-primary fill-current" />,
      text: "5.0 Stars",
      subtext: "Yelp Reviews",
      href: YELP_URL,
    },
    {
      icon: <Shield className="h-6 w-6 text-primary" />,
      text: "Since 2007",
      subtext: "18+ Years Experience",
    },
    {
      icon: <MapPin className="h-6 w-6 text-primary" />,
      text: "Locally Owned",
      subtext: "East Petersburg, PA",
    },
  ];

  return (
    <div className={`py-6 border-y ${isDark ? 'bg-secondary border-secondary-foreground/10' : 'bg-muted/50 border-border'} ${className}`}>
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-6">
          {items.map((item, index) => {
            const content = (
              <>
                <div className={`p-3 rounded-full ${isDark ? 'bg-secondary-foreground/5' : 'bg-background shadow-sm'}`}>
                  {item.icon}
                </div>
                <div>
                  <div className={`font-bold ${isDark ? 'text-white' : 'text-foreground'}`}>{item.text}</div>
                  <div className={`text-xs ${isDark ? 'text-secondary-foreground/70' : 'text-muted-foreground'}`}>{item.subtext}</div>
                </div>
              </>
            );

            return item.href ? (
              <a
                key={index}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-col items-center text-center gap-2 transition-opacity hover:opacity-80"
                data-testid={`link-trust-${index}`}
              >
                {content}
              </a>
            ) : (
              <div key={index} className="flex flex-col items-center text-center gap-2">
                {content}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
